import { render } from "./MatchesPage.vue?vue&type=template&id=1f7b89a7&scoped=true"
import script from "./MatchesPage.vue?vue&type=script&lang=js"
export * from "./MatchesPage.vue?vue&type=script&lang=js"

import "./MatchesPage.vue?vue&type=style&index=0&id=1f7b89a7&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7b89a7"]])

export default __exports__